var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.insideList)?_c('li',{staticClass:"binds-divider",class:[_vm.$bindsActiveTheme]}):_c('hr',{staticClass:"binds-divider",class:[_vm.$bindsActiveTheme]})
}
var staticRenderFns = []

export { render, staticRenderFns }